export const NoAlcoholIcon = ({
  width = '24',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="10" stroke="black" strokeWidth="0.7" />
        <path
          d="M8.79999 20H15.2"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 10.4H10.4M16 10.4H14.9256"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 14.4V20"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.2456 8.2456C8.08481 8.95253 8.00245 9.67502 8 10.4C8.00004 11.0937 8.18045 11.7754 8.52354 12.3782C8.86663 12.9811 9.3606 13.4844 9.95695 13.8387C10.5533 14.193 11.2315 14.3861 11.9251 14.3991C12.6186 14.4121 13.3036 14.2445 13.9128 13.9128M9.3104 4.7848C9.4 4.5344 9.4976 4.272 9.6 4H14.4C15.6 7.2 16 8.8 16 10.4C16 10.7256 15.96 11.0472 15.884 11.3584"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.5 5.5L5.50002 18.4998"
          stroke="black"
          strokeWidth="0.7"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};
